import { Box, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { IPlanSubscriptions } from "../ModalSubscriptions"; // Ajuste o caminho se necessário
import { LinkCore } from "src/Pages/components/LinkCore/LinkCore";
import { ButtonCore } from "src/Pages/components/ButtonCore/ButtonCore";
import { UrlConfig } from "src/shared/Utils/paths";
import { UseFormAbandonment } from "../Hooks/UseFormAbandonment";
import { useEffect } from "react";

interface SubscriptionFailureProps {
  planSelected: IPlanSubscriptions;
  setStep: (step: number) => void; // Para voltar ao passo do cartão (step 3)
  setOpenModal: () => void; // Para fechar o modal
}

export const SubscriptionFailure = ({
  planSelected,
  setStep,
  setOpenModal,
}: SubscriptionFailureProps) => {
  const { handleSubmit } = UseFormAbandonment();

  useEffect(() => {
    handleSubmit({ event: "CHECKOUT_FAILED" });
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        textAlign: "center",
        p: 4,
        gap: 3,
        bgcolor: "background.paper",
        borderRadius: "inherit",
      }}
    >
      <ErrorOutlineIcon sx={{ fontSize: 80, color: "error.main" }} />
      <Typography
        variant="h4"
        component="h2"
        sx={{ fontWeight: "bold", color: "text.primary" }}
      >
        Pagamento Recusado
      </Typography>
      <Typography variant="h6" sx={{ color: "text.secondary" }}>
        Não foi possível processar o pagamento para o plano{" "}
        <strong>{planSelected.title}</strong>.
      </Typography>
      <Typography variant="body1" sx={{ color: "text.secondary", mb: 3 }}>
        Por favor, verifique os dados do seu cartão de crédito e tente
        novamente. Se o problema persistir, entre em contato com o suporte.
      </Typography>

      <Box sx={{ display: "flex", gap: 2 }}>
        <LinkCore to={UrlConfig.help.url}>
          <ButtonCore
            variant="outlined"
            color="primary"
            size="large"
            title="Tentar Novamente"
            onClick={() => setStep(3)} // Volta para a tela do cartão
            sx={{ borderRadius: "20px", px: 4, py: 1.5 }}
          />
        </LinkCore>
        <LinkCore to={UrlConfig.help.url}>
          <ButtonCore
            variant="contained"
            color="secondary"
            size="large"
            title="Fechar"
            onClick={setOpenModal} // Fecha o modal
            sx={{ borderRadius: "20px", px: 4, py: 1.5 }}
          />
        </LinkCore>
      </Box>
    </Box>
  );
};
